import React, { useEffect } from 'react'

import Aos from 'aos'
import 'aos/dist/aos.css'
import { Link } from 'react-router-dom'

export default function Contact() {
    useEffect(() => {
        Aos.init({
            duration: 1000
        })
    }, [])
    
    return (
        <>
<div className="page-header pb-5">
    <div className="container text-center py-5">
        <h1 className="display-4 text-uppercase mb-3 animated slideInDown text-light">Contact</h1>
        <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center text-uppercase mb-0">
                <li className="breadcrumb-item">
                    <a className="text-white" href="#">Home</a>
                </li>
                <li className="breadcrumb-item">
                    <a className="text-white" href="#">Pages</a>
                </li>
                <li className="breadcrumb-item text-primary active" aria-current="page">Contact</li>
            </ol>
        </nav>
    </div>
</div>
{/* Contact Start */}
 <div className="container-fluid my-5">
      <div className="container">
          <div className="section-title text-center mb-5" data-aos="fade-up" data-aos-delay="100">
            <div className="sub-style">
                <h5 className="sub-title text-primary px-3 mb-3">Contact Us</h5>
                <h2 className="display-6 mb-4">feel free to contact us</h2>
            </div>
        </div>
        <div className="reservation position-relative overlay-top overlay-bottom">
          <div className="row align-items-center">
            <div className="col-lg-6 my-5 my-lg-0">
              <div className="p-5">
                <div className="mb-4">
                  <h1 className="display-3 text-primary">MARSHAL Herbs & Spices</h1>
                  <h1 className="text-white">For Import & Export herbs</h1>
                </div>
                <p className="text-white">
                  We specialize in high-quality medicinal and aromatic herbs. 
                  Our products are 100% natural with international quality certificates 
                  and full compliance with global export standards.
                </p>
                <ul className="list-inline text-white m-0">
                  <li className="py-2">
                    <i className="fa fa-check text-primary mr-3"></i>
contact@marshal.com                  </li>
                  <li className="py-2">
                    <i className="fa fa-check text-primary mr-3"></i>
01222461667                  </li>
                  <li className="py-2">
                    <i className="fa fa-check text-primary mr-3"></i>
Somosta- Bani Swayf - Egypt                  </li>
                </ul>
                <div className="mt-4">
                  <Link to="/products" className="text-primary font-weight-bold">
                    View All Products →
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div 
                className="text-center p-5" 
                style={{ background: 'rgba(51, 33, 29, .8)' }}
              >
                <h1 className="text-white mb-4 mt-5">Contact MARSHAL</h1>
                <form className="mb-5">
                  <div className="form-group">
                    <input 
                      type="text" 
                      className="form-control bg-transparent border-primary p-4" 
                      placeholder="Full Name"
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <input 
                      type="email" 
                      className="form-control bg-transparent border-primary p-4" 
                      placeholder="Email Address"
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <input 
                      type="tel" 
                      className="form-control bg-transparent border-primary p-4" 
                      placeholder="Phone Number"
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <select className="custom-select bg-transparent border-primary px-4" style={{ height: '49px' }}>
                      <option selected>Inquiry Type</option>
                      <option value="import">Import</option>
                      <option value="export">Export</option>
                      <option value="product">Product Information</option>
                      <option value="other">Other Inquiry</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <textarea 
                      className="form-control bg-transparent border-primary p-4" 
                      placeholder="Your Message"
                      rows="3"
                    ></textarea>
                  </div>
                  
                  <div>
                    <button className="btn btn-primary btn-block font-weight-bold py-3" type="submit">
                      Send Message
                    </button>
                  </div>
                </form>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

{/* Google Map Start */}
<div className="container-fluid p-0 wow fadeIn" data-wow-delay="0.3s">
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
        frameBorder="0" allowFullScreen="" aria-hidden="false" tabIndex="0"
        style={{width: "100%", height: "500px", filter: "grayscale(100%) invert(92%) contrast(83%)", border: "0"}}></iframe>
</div>
{/* Google Map End */}
        </>
    )
}